import "./index.css";
import "./assets/scss/main.scss";
import React, {useEffect} from "react";
import {
  createBrowserRouter,
  createMemoryRouter,
  RouterProvider,
  useLocation,
  Navigate,
} from "react-router-dom";
import Home from "@/pages/Home";
import Flow from "@/pages/flow/Flow";
import {RootPage} from "./pages/RootPage";
import AppProvider from "./providers/AppProvider";

const RouteWithTitle: React.FC<{title: string; element: React.ReactNode}> = ({
  title,
  element,
}) => {
  const location = useLocation();

  useEffect(() => {
    document.title = title;
  }, [title, location]);

  return <>{element}</>;
};

// Detect if we're running inside an iframe
const isIframe = window.self !== window.top;

// Define routes configuration
const routesConfig = [
  {
    path: "/",
    element: <RootPage />,
    children: [
      {
        path: "",
        element: <RouteWithTitle title="Home" element={<Home />} />,
      },
      {
        path: "flow",
        element: <RouteWithTitle title="Flow" element={<Flow />} />,
      },
      {
        path: "agents/:id/workflow",
        element: <RouteWithTitle title="Flow" element={<Flow />} />,
      },
      {
        path: "*",
        element: <Navigate to="/flow" replace />,
      },
    ],
  },
];

// Use memory router for iframe context, browser router otherwise
const router = isIframe
  ? createMemoryRouter(routesConfig, {
      initialEntries: ["/flow"], // Start at /flow when in iframe
      initialIndex: 0,
    })
  : createBrowserRouter(routesConfig);

const App: React.FC = () => {
  return (
    <AppProvider>
      <RouterProvider router={router} />
    </AppProvider>
  );
};

export default App;
